const oidc = {
    logout_success: 'You have successfully signed out.',
};
export default oidc;
